import { render } from "./PageCamber.vue?vue&type=template&id=b5fcaa20"
import script from "./PageCamber.vue?vue&type=script&lang=js"
export * from "./PageCamber.vue?vue&type=script&lang=js"

import "./PageCamber.vue?vue&type=style&index=0&id=b5fcaa20&lang=scss"

import exportComponent from "D:\\PhpstormProjects\\alignment-page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__